import * as yup from 'yup';
import { Material } from 'types';
import { areDatesOnTheSameDay, checkDateLowerTimeInterval, checkDateUpperTimeInterval } from 'utils/date';

export const productionFormSchema = (
  pt: any,
  materials: Material[],
  closureDate: Date | null,
  twoMonthAfterClosureDate: Date | null,
): yup.AnyObjectSchema =>
  yup.object().shape({
    productionDate: yup
      .date()
      .typeError(pt('validation.productionDate.invalid'))
      .nullable()
      .required(pt('validation.productionDate.required'))
      .test('previousThanToday', pt('validation.productionDate.previousThanToday'), (value, _) => {
        const today = new Date();
        return checkDateUpperTimeInterval(value, today);
      })
      .test('alreadyClosedMonth', pt('validation.productionDate.alreadyClosedMonth'), (value, _) =>
        checkDateLowerTimeInterval(value, closureDate),
      )
      .test('datePreviousThanClosure', pt('validation.productionDate.previousThanClosure'), (value, _) =>
        checkDateUpperTimeInterval(value, twoMonthAfterClosureDate),
      ),
    productionTime: yup
      .date()
      .typeError(pt('validation.productionTime.invalid'))
      .nullable()
      .required(pt('validation.productionTime.required'))
      .when('productionDate', {
        is: (productionDate: Date | null) => productionDate && areDatesOnTheSameDay(productionDate, new Date()),
        then: yup
          .date()
          .typeError(pt('validation.productionTime.invalid'))
          .nullable()
          .test('previousThanToday', pt('validation.productionDate.previousThanToday'), (value, _) => {
            const today = new Date();
            return checkDateUpperTimeInterval(value, today);
          }),
      }),
    productionMaterials: yup
      .array()
      .of(
        yup.object().shape({
          conditioningQuantity: yup.lazy(conditionningQuantity => {
            if (!!conditionningQuantity) {
              return yup
                .number()
                .typeError(pt('validation.conditioningQuantity.invalid'))
                .moreThan(0, pt('validation.conditioningQuantity.invalid'));
            }
            return yup.number().transform(value => (isNaN(value) ? 0 : value));
          }),
          weight: yup.lazy(weight => {
            if (!!weight) {
              return yup
                .number()
                .typeError(pt('validation.weight.invalid'))
                .moreThan(0, pt('validation.weight.invalid'));
            }
            return yup.number().transform(value => (isNaN(value) ? 0 : value));
          }),
        }),
      )
      .test('atLeastOne', 'validation.productionMaterials.atLeastOne', (productionMaterials: any) => {
        return (
          Boolean(productionMaterials) &&
          productionMaterials?.some((productionMaterial: any) => !!productionMaterial.weight)
        );
      }),
  });
